import type { ExpertType, SlotType } from "helpers/getNextAvailableSlotForExpert";
import { getNextAvailableSlotForExpert } from "helpers/getNextAvailableSlotForExpert";

export type TopicType = {
  description: string;
  id: string;
  name: string;
  slug: string;
  userList: string[];
};

export const getNextAvailableSlotForTopics = (
  topics: TopicType[] | undefined,
  slots: SlotType | undefined
) => {
  const topicsFirstAvailableSlots: { [key: string]: string | null } = {};
  if (topics && slots) {
    const topicsExpertsAvailableSlots = topics.map((topic) => {
      const modifiedUserList = topic.userList.map((user: string) => {
        return { username: user };
      });

      return {
        topicName: topic.name,
        expertsSlots: getNextAvailableSlotForExpert(modifiedUserList as ExpertType[], slots),
      };
    });

    topicsExpertsAvailableSlots.forEach((topic) => {
      const expertSlotsInNumber = Object.values(topic.expertsSlots).map((value) => new Date(value).getTime());

      const firstTopicExpertsAvailableSlot = Math.min(...expertSlotsInNumber);

      topicsFirstAvailableSlots[topic.topicName as string] =
        firstTopicExpertsAvailableSlot !== Infinity
          ? new Date(firstTopicExpertsAvailableSlot).toISOString()
          : null;
    });
  }

  return topicsFirstAvailableSlots;
};
